import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { AccordionDetails, Skeleton, Stack, Typography } from "@mui/material";

export const DeliveryProposalFormLayout = (props: {
  title: string;
  isLoading: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <BaseAccordion sx={{ borderRadius: { xs: "0", sm: "inherit" } }}>
      <BaseAccordionSummary>
        <Stack>
          <Typography variant="body1" fontWeight={700} fontSize={18}>
            {props.title}
          </Typography>
        </Stack>
      </BaseAccordionSummary>
      <AccordionDetails>
        <Stack pb={2} px={0}>
          {props.isLoading ? (
            <Stack spacing={2}>
              <Skeleton variant="rounded" height={40} />
              <Skeleton variant="rounded" height={40} />
              <Skeleton variant="rounded" height={40} />
              <Skeleton variant="rounded" height={40} />
            </Stack>
          ) : (
            <Stack spacing={2}>{props.children}</Stack>
          )}
        </Stack>
      </AccordionDetails>
    </BaseAccordion>
  );
};
